import React from 'react';
import { useTranslation } from 'react-i18next';
import SEO from '../components/SEO';

const LegalPage = () => {
    const { t } = useTranslation();
    const sections = t('legal.sections', { returnObjects: true }) || [];

    return (
        <>
            <SEO 
                title="Termeni și Condiții - Oana Tenea Psihoterapeut"
                description="Termenii și condițiile de utilizare a site-ului oanatenea.ro și a serviciilor psihoterapeutice oferite de Oana Tenea."
                path="/termeni-si-conditii"
            />
            
            <div className="bg-stone-50 dark:bg-stone-950 text-stone-800 dark:text-stone-200 py-16 sm:py-24 transition-colors duration-300">
                <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-4xl">
                    <div className="text-center mb-16">
                        <span className="inline-flex items-center px-4 py-1.5 rounded-full bg-stone-100 dark:bg-stone-800 text-stone-700 dark:text-stone-300 text-xs font-semibold tracking-wider uppercase mb-4 border border-stone-200 dark:border-stone-700">
                            Informații Legale
                        </span>
                        <h1 className="font-display text-4xl sm:text-5xl font-bold text-stone-900 dark:text-stone-100 tracking-tight">
                            {t('legal.title')}
                        </h1>
                        <p className="mt-4 text-base sm:text-lg text-stone-600 dark:text-stone-400">
                            {t('legal.subtitle')}
                        </p>
                        <div className="w-16 h-1 bg-terracotta mx-auto mt-6 rounded-full"></div>
                    </div>

                    <div className="bg-white dark:bg-stone-900 rounded-3xl p-8 sm:p-12 shadow-elevated border border-stone-200/80 dark:border-stone-800 space-y-8">
                        {Array.isArray(sections) && sections.map((section, index) => (
                            <section key={index} className="border-b border-stone-100 dark:border-stone-800/80 pb-8 last:border-b-0 last:pb-0">
                                <h2 className="font-display text-xl sm:text-2xl font-bold text-stone-900 dark:text-stone-100 mb-3">
                                    {section.title}
                                </h2>
                                <p className="text-stone-700 dark:text-stone-300 leading-relaxed text-sm sm:text-base mb-4">
                                    {section.title && section.title.includes('10.') ? 
                                        section.content.replace('{{date}}', new Date().toLocaleDateString(t('locale') || 'ro-RO')) : 
                                        section.content
                                    }
                                </p>
                                {section.list && (
                                    <ul className="list-disc list-inside text-stone-600 dark:text-stone-400 space-y-1.5 text-sm sm:text-base pl-2">
                                        {section.list.map((item, i) => (
                                            <li key={i}>{item}</li>
                                        ))}
                                    </ul>
                                )}
                            </section>
                        ))}
                    </div>
                </div>
            </div>
        </>
    );
};

export default LegalPage;
